// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nkBK","delete":"styles_delete__3R6Vq","update":"styles_update__3GE5-","add":"styles_add__1SvHH"};